import styled from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import CustomLink from 'components/Globals/Base/Link';
import Heading from 'styles/typography/Heading';
import { Theme, getColor } from 'styles/theme';

export const SitemapStyledLink = styled(CustomLink)<{ theme: Theme }>`
  cursor: pointer;
  text-decoration: none;
  color:  ${getColor('neutralBlack')};
  padding-left: 3px;

  &:hover {
    text-decoration: underline;
    color: ${getColor('textLink')};
  }
`;

export const SitemapPageWrapper = styled.div`
  padding: 0 20px;
  font-family: ${font.graphikCond};

  a {
    padding-left: 0;
  }

  h2 {
    font-weight: 600;
  }

  li {
    list-style: none;
    padding-bottom: 10px;
    display: flex;
    justify-content: center;
  }

  ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: 2rem;
    padding: 0;
    margin-bottom: 24px;
  }

  .sitemap-page-title {
    margin-top: 16px;
  }

  .sitemap-grid-articles {
    grid-template-columns: repeat(1,1fr);
    li {
      justify-content: flex-start;
    }
  }

  .sitemap-grid-companies {
    grid-template-columns: repeat(3,1fr);
    li {
      justify-content: flex-start;
    }
  }

  .sitemap-grid-years {
    grid-template-columns: repeat(6,1fr);
    @media (${breakpoint.mdMin}) { 
      grid-template-columns: repeat(12,1fr);
    }
    @media (${breakpoint.lgMin}) { 
      grid-template-columns: repeat(20,1fr);
    }
  }

  .sitemap-grid-months {
    grid-template-columns: repeat(4,1fr);
    @media (${breakpoint.mdMin}) { 
      grid-template-columns: repeat(6,1fr);
    }
    @media (${breakpoint.lgMin}) { 
      grid-template-columns: repeat(12,1fr);
    }
  }

  .sitemap-grid-days {
    grid-template-columns: repeat(6,1fr);
    @media (${breakpoint.mdMin}) { 
      grid-template-columns: repeat(12,1fr);
    }
    @media (${breakpoint.lgMin}) { 
      grid-template-columns: repeat(20,1fr);
    }
  }

  ol[class^='sitemap-grid'] {
    display: grid;
    grid-row-gap: 1.25rem;
    margin-top: 16px;
  }
`;

export const Title = styled(Heading)`
  padding-bottom: 0px;
  margin: 24px 0;

@media (${breakpoint.lgMin}) { 
  padding-bottom: 0px;
  margin: 48px 0;
}
`;

export const SitemapBreadcrumbsWrapper = styled.div`
  padding: 10px 0;
`;

export const TagList = styled.ol<{ theme: Theme }>`
  display: flex;
  flex-flow: row wrap;
  gap: 8px 16px;
  border-top: 1px solid ${getColor('borderSecondary')};
  margin: 24px 0 0 0;
  padding-top: 24px;

  @media (${breakpoint.mdMin}) { 
    margin: 24px 0 0 16px;
    padding-top: 24px;
  }
`;

export const Tag = styled.li<{ theme: Theme }>`
  font-size: 14px;
  font-weight: 500;
  line-height: 120%;
  letter-spacing: 0.5px;
  text-transform: uppercase;

  &.tag {
    padding: 0;

    &::after {
      content: '';
      border-right: 1px solid ${getColor('borderSecondary')};
      position: relative;
      left: 8px;
    }
  }
  .link {
    padding: 0;
    color: ${getColor('textLink')};
  }
`;

export const LetterPickerWrapper = styled.div`
  margin: 24px 0;
`;
